import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../function/helper";
import DiscountInput from "./DiscountInput";
import "./OrderGetPriceModal.css";

export default function OrderGetPriceModal({
  getSellerData,
  pricesData,
  orderPayload,
  open,
  onClose,
  onCloseAll,
  messages,
  refetch,
}) {
  const [selectedService, setSelectedService] = useState(null);
  const [discountCode, setDiscountCode] = useState("");
  const queryClient = useQueryClient();

  const { isPending, mutate: mutateStoreDigikalaOrder } = useMutation({
    mutationKey: ["StoreDigikalaOrder"],
    mutationFn: payload =>
      postRequestByAuth("/v2/digikala/order/new", payload).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res?.data?.message,
            showConfirmButton: true,
            confirmButtonText: "متوجه شدم",
          });
          queryClient.refetchQueries({
            queryKey: ["DigikalaSeller"],
          });
          refetch();
          onCloseAll();
          return;
        }
        Swal.fire({
          icon: "error",
          text: res.message,
          showConfirmButton: true,
          confirmButtonText: "متوجه شدم",
        });
      }),
  });

  function onSubmit() {
    if (isPending) {
      return;
    }

    if (!selectedService) {
      Swal.fire({
        icon: "warning",
        text: "لطفا سرویس دهنده دلخواه را انتخاب کنید",
        confirmButtonText: "باشه",
      });
      return;
    }

    orderPayload = {
      ...orderPayload,
      discountCode: discountCode || undefined,
      company: {
        id: selectedService?.company?.id,
        typeId: selectedService?.company?.typeId,
      },
      sourceId: getSellerData?.seller?.defaultAddressId,
    };

    mutateStoreDigikalaOrder(orderPayload);
  }

  if (!pricesData || !open) return null;

  return (
    <div
      className="modal show d-block dgk px-2"
      tabIndex={-1}
      role="dialog"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl dgk-modal"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">نتیجه استعلام</h4>
          </div>

          <div className="modal-body">
            {pricesData?.data?.map((item, indx) => (
              <div
                onClick={() => setSelectedService(item)}
                key={indx}
                className="dgk-item"
                style={{ flexDirection: "column", alignItems: "stretch" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div className="dgk-left">
                    <div className="dgk-rc">
                      <Form.Check
                        type="radio"
                        name="selectedService"
                        value={item}
                        size="lg"
                        className="d-inline-block mx-1 selectedService dgk-radio"
                        checked={
                          selectedService?.company?.id === item.company?.id
                        }
                        onChange={() => setSelectedService(item)}
                      />
                    </div>
                    <img
                      src={item.company?.image}
                      className="dgk-logo"
                      alt={item.company?.name}
                    />
                    <div className="dgk-meta">
                      <div className="dgk-name">{item.company?.name}</div>
                      <div className="dgk-type">{item.company?.typeName}</div>
                    </div>
                  </div>

                  <div style={{ flex: 1 }} />

                  <div className="dgk-price">
                    <div>
                      <span style={{ fontSize: 18, fontWeight: 800 }}>
                        {item?.finalPrice?.toLocaleString()}
                      </span>
                      <span style={{ fontSize: 15, marginRight: 6 }}>ریال</span>
                    </div>
                  </div>
                </div>

                <div className="dgk-details">
                  <div className="dgk-details-grid">
                    <div className="dgk-detail-card">
                      <div className="dgk-detail-title">مبلغ سرویس دهنده</div>
                      <div style={{ fontWeight: 700 }}>
                        {item?.detail?.price?.toLocaleString()} ریال
                      </div>
                    </div>

                    <div className="dgk-detail-card">
                      <div className="dgk-detail-title">جمع آوری</div>
                      <div style={{ fontWeight: 700 }}>
                        {item?.detail?.collecting?.toLocaleString()} ریال
                      </div>
                    </div>

                    {item?.detail?.insurance > 0 && (
                      <div className="dgk-detail-card">
                        <div className="dgk-detail-title">بیمه</div>
                        <div style={{ fontWeight: 700 }}>
                          {item.detail.insurance.toLocaleString()} ریال
                        </div>
                      </div>
                    )}

                    <div className="dgk-detail-card">
                      <div className="dgk-detail-title">بسته بندی</div>
                      <div style={{ fontWeight: 700 }}>
                        {item?.detail?.packaging?.toLocaleString()} ریال
                      </div>
                    </div>

                    <div className="dgk-detail-card">
                      <div className="dgk-detail-title">پرینت فاکتور</div>
                      <div style={{ fontWeight: 700 }}>
                        {item?.detail?.print?.toLocaleString()} ریال
                      </div>
                    </div>
                    <div className="dgk-detail-card">
                      <div className="dgk-detail-title">پیامک</div>
                      <div style={{ fontWeight: 700 }}>
                        {item?.detail?.SMS?.toLocaleString()} ریال
                      </div>
                    </div>

                    {item?.detail?.tax > 0 && (
                      <div className="dgk-detail-card">
                        <div className="dgk-detail-title">مالیات</div>
                        <div style={{ fontWeight: 700 }}>
                          {item?.detail?.tax?.toLocaleString()} ریال
                        </div>
                      </div>
                    )}

                    <div className="dgk-detail-card">
                      <div className="dgk-detail-title">خدمات فنی و مهندسی</div>
                      <div style={{ fontWeight: 700 }}>
                        {item?.detail?.technicalServices?.toLocaleString()} ریال
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {messages?.length > 0 && (
              <div className="dgk-note dgk-details-grid">
                {messages.map((message, idx) => (
                  <div
                    className="alert alert-danger w-100 mx-0 mx-md-5"
                    key={idx}
                  >
                    {message}
                  </div>
                ))}
              </div>
            )}

            {messages?.length > 0 && (
              <p className="text-danger px-2 mb-0">
                می‌توانید با زدن دکمه لغو و استعلام هزینه، مجددا تلاش کنید
              </p>
            )}

            <DiscountInput onChange={value => setDiscountCode(value)} />
            <LoadingButton
              center
              isLoading={isPending}
              type="button"
              className="btn-success"
              title={
                isPending ? "در حال ارسال" : "ثبت مرسوله و دریافت بارکد پستی"
              }
              onClick={() => onSubmit()}
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                onClose();
                setSelectedService(null);
              }}
            >
              لغو
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
